import React from "react";
import { social_links } from "../About/data";

function Contact() {
  return (
    <div className="flex bg-gray-900 w-fit">
      <div className="sticky top-0 mx-0 hidden h-screen rounded-r-3xl md:flex w-2/6 justify-center items-center bg-white">
        <h1 className="text-black text-center text-5xl font-bold tracking-widest">
          $ CONTACT
        </h1>
      </div>
      <div className="flex flex-1 flex-col gap-5 p-5 pt-9">
        <h1 className="text-white font-bold text-xl">- GET IN TOUCH</h1>
        <div className="flex flex-col p-3 gap-5">
          <p className=" text-center text-white  text-4xl">Don't be shy</p>
          <p className=" text-center text-white lg:text-lg md:text-sm  text-sm px-10">
            Feel free to get in touch with me. I am always open to discussing
            new projects, creative ideas or opportunities to be part of your
            visions.
          </p>
          <div className="flex flex-col  w-full  justify-center gap-4">
            <div className="flex w-full lg:flex-row md:flex-row flex-wrap sm:flex-row flex-col gap-3  justify-between md:px-10 sm-px-2 px-2 ">
              <input
                className="p-3 bg-gray-700 flex-1 w-full min-w-32 text-white rounded-full"
                placeholder="Your Name"
              ></input>
              <input
                className="p-3 bg-gray-700 flex-1 min-w-32 w-full text-white rounded-full"
                placeholder="Your Email"
              ></input>
              <input
                className="p-3 bg-gray-700 flex-1 min-w-32  w-full text-white rounded-full"
                placeholder="Your Subject"
              ></input>
              <textarea
                rows={5}
                className="p-3 w-full resize-none bg-gray-700 text-white rounded-2xl"
                placeholder="Your Message"
              ></textarea>
            <button className=" flex gap-2 items-center text-white border hover:bg-yellow-500 hover:border-white hover:text-black transition-all border-yellow-500 p-2 text-l font-bold rounded-full self-center md:self-start ">
              Send Message
              <div className="bg-yellow-500 rounded-full p-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-3 h-3"
                >
                  <path d="M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z" />
                </svg>
              </div>
            </button>
            </div>

          </div>
        </div>
        <hr className="w-60 border border-gray-500 self-center"></hr>
        {/* Social Link */}
        <div className="flex flex-col h-40">
          <div className="flex justify-evenly w-full p-9 pt-6">
            {social_links.map((social) => (
              <SocialLink social={social} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function SocialLink({ social }) {
  let { link, name, img } = social;
  return (
    <a
      href={link}
      className="hover:w-12 w-10 transition-all"
      target="_blank"
      rel="noreferrer"
    >
      <div className="w-full flex justify-center items-center flex-col">
        <img className="w-full" src={img} alt={name}></img>
        {/* <h3 className="text-white pt-3">{name}</h3> */}
      </div>
    </a>
  );
}

export default Contact;
